export default __webpack_public_path__ + "static/media/second.7b0c9f29.svg";